import { useLiveUpdates } from '~/composables/useLiveUpdates'
import { useSyncQueue } from '~/composables/useSyncQueue'
import { DEVICE_EVENT, readDeviceEvent } from '~/utils/scanSource/deviceBridge'

/**
 * Live updates (task 2496) for the whole app, beside the screens' own (`useLiveRefresh`).
 *
 * - The driver's own hints (a clerk settled a move of theirs) refresh the Your Work count.
 * - A (re)connect proves the API answers: the queue is nudged to ask, as for the Wi-Fi coming back.
 *   Only a nudge - the queue's own rules decide what is sent and when (utils/syncQueue).
 * - The tablet's report that the internet is back starts a reconnect at once, rather than at the
 *   end of a back-off that may have reached a minute.
 */
export default defineNuxtPlugin(() => {
  const liveUpdates = useLiveUpdates()
  const queue = useSyncQueue()

  liveUpdates.listen({
    interest: () => ({ topics: ['needs-attention'], gang: null }),
    onHint: () => { void queue.refreshCounts() },
    onConnected: () => {
      queue.nudge()
      void queue.refreshCounts()
    },
  })

  let hadInternet: boolean | null = null
  window.addEventListener(DEVICE_EVENT, (event) => {
    const read = readDeviceEvent((event as CustomEvent).detail)
    if (read?.kind !== 'wifi') return
    const hasInternet = read.connected && read.internet
    if (hasInternet && hadInternet === false) liveUpdates.retryNow()
    hadInternet = hasInternet
  })
})
